import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import callIdMasking from '../../Res/Icon/callMaskAgreement.svg';

const CallerIdMaskingAgreementModal = ({
  isOpen,
  toggle,
  onConfirm,
  onCancel,
  user,
}) => {
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileDetails, setFileDetails] = useState(null);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (allowedTypes.includes(file.type)) {
        setFileDetails(file);
        setFileUploaded(true);
      }
      else {
        toast.error('Invalid file type. Please select a PDF or DOCX file.');
        setFileUploaded(false);
      }
    }
  };

  const onConfirmPress = async (e) => {
    if (fileUploaded && fileDetails) {
      try {
        console.log("File details to be passed:", fileDetails);
        onConfirm(e, fileDetails);

      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      toast.error('Please upload a file before proceeding.');
    }
  };


  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader>
        <img
          src={callIdMasking}
          alt="Warning"
          style={{ width: '30px', marginRight: '10px' }}
        />
        Caller ID Masking Agreement
      </ModalHeader>
      <ModalBody>
        <p>A confirmation email or letter from the customer is required to enable this tool. Please attach a copy of an acknowledgement of the Caller ID Masking Agreement from the customer. An email or signed pdf is acceptable.</p>


        <div className="d-flex align-items-center">
          <span style={{ whiteSpace: 'nowrap' }}>Customer Acknowledgement:</span>
          <Input
            type="file"
            style={{ marginLeft: '10px', width: 'auto' }}
            accept=".pdf,.doc,.docx"
            onChange={handleFileUpload}
          />
        </div>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button outline color="secondary" onClick={onCancel}>Cancel</Button>
        <Button color="primary" onClick={onConfirmPress} disabled={!fileUploaded}>Proceed</Button>
      </ModalFooter>
    </Modal>
  );
};


const mapStateToProps = store => ({
  user: store.AppState.user,
});

export default connect(mapStateToProps)(CallerIdMaskingAgreementModal);